export default __webpack_public_path__ + "static/media/main-app-black-(orig).aca8fe28.png";